import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const SectionItemArrow = styled.div`
    background: url('${process.env.PUBLIC_URL}/images/icons/arrow-right.svg') no-repeat center;
    background-size: contain;
    height: 1rem;
    min-width: 1rem;

    ${({hideArrow}) => hideArrow && 'display: none;'}
`;

export const SectionItemWrapper = styled(Link)`
    align-items: center;
    border: 1px solid #BDBDBD;
    border-radius: 1rem;
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.5rem 1rem 0.875rem;
    transition: 0.25s ease;

    &.active,
    &:hover {
        background-color: var(--main-color);
        border-color: var(--main-color);
        color: #FFF;

        ${SectionItemArrow} {
            display: none;
        }
    }
`;

export const SectionItemText = styled.p`
    margin-right: 0.5rem;
`;
